/** Előfizetés díja — havi vagy éves (−discount% az éves 12 hónapra). */
export function subscriptionCheckoutPrice(pkg, billingInterval, annualDiscountPercent = 20) {
  const monthly = Number(pkg.price);
  if (billingInterval === "year") {
    const disc = Number(annualDiscountPercent) || 20;
    return Math.max(1, Math.round(monthly * 12 * (1 - disc / 100)));
  }
  return monthly;
}

export function subscriptionCreditsGrant(pkg, billingInterval) {
  const c = Number(pkg.credits);
  return billingInterval === "year" ? c * 12 : c;
}
